module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard-step1.2f64c06d.png";